var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConfirmation = function SvgConfirmation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 81,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    x: 0.5,
    y: 0.448,
    fill: "url(#confirmation_svg__a)",
    rx: 28
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#confirmation_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m36.5 46.792 18.384-18.386 2.83 2.828L36.5 52.448 23.772 39.72l2.828-2.828z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "confirmation_svg__a",
    x1: 2.382,
    x2: 95.935,
    y1: 4.448,
    y2: 42.555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0075FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F58EA"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "confirmation_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.5 16.448h48v48h-48z"
  })))));
};
export default SvgConfirmation;